// Mock data for Education Intelligence Group (EIG) website
// NOTE: This is front-end mock data. Backend (contact email via chosen provider
// and Stripe report purchases) will replace the relevant parts later.

export const CONTACT = {
  address: 'Boulevard Plaza Tower 1, Suite 1901, Level 19 – Sheikh Mohammed bin Rashid Blvd – Dubai',
  email: 'contact@educationintelligencegroup.com',
  phone: '+971 4 424 5142',
  mapQuery: 'Boulevard Plaza Tower 1, Downtown Dubai',
};

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Consultants at EIG', path: '/consultants' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Contact', path: '/contact' },
  { label: 'Critical Thinking', path: '/critical-thinking' },
  { label: 'Reports', path: '/reports' },
];

export const HERO_SLIDES = [
  {
    id: 1,
    kicker: 'The Knowledge Economy Report | 2019',
    title: 'Where new school supply is located',
    subtitle:
      'In-depth intelligence on the UAE education landscape — supply, demand, pricing and positioning.',
    cta: 'Read the Report',
    ctaLink: '/reports',
    image:
      'https://images.unsplash.com/photo-1607414851776-f2fcc379fb48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxEdWJhaSUyMHNreWxpbmV8ZW58MHx8fHwxNzkwODQ5MjY0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    kicker: 'Market Intelligence',
    title: 'Clarity for schools, operators & investors',
    subtitle:
      'Contextual solutions to the challenges of an expanding education sector — from the people who know it best.',
    cta: 'Explore Solutions',
    ctaLink: '#solutions',
    image:
      'https://images.unsplash.com/photo-1651467606797-e1c660cf3fda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxEdWJhaSUyMHNreWxpbmV8ZW58MHx8fHwxNzkwODQ5MjY0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    kicker: 'Data • Insight • Strategy',
    title: 'Illuminating insights for the UAE education sector',
    subtitle:
      'A consultancy solely dedicated to education and helping businesses within the sector succeed.',
    cta: 'Get in Touch',
    ctaLink: '/contact',
    image:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1920&auto=format&fit=crop',
  },
];

export const SOLUTIONS = [
  {
    icon: 'FileBarChart',
    title: 'Market Reports',
    text: 'Sign up for regular reports on the critical issues shaping and defining the education sector within the UAE.',
  },
  {
    icon: 'FileText',
    title: 'Bespoke Reports',
    text: 'EIG is, in some instances, willing to work on bespoke reports to deliver unique insights based on key data specific to your business.',
  },
  {
    icon: 'Compass',
    title: 'Mentoring',
    text: 'We work with you on your projects, a guiding hand from initial concept through to execution — an honest partner to stress test your ideas and plans.',
  },
  {
    icon: 'Users',
    title: 'Introductions & Forums',
    text: 'The chances are we have worked with, or know, your peers. Where there is an opportunity for sharing, we make introductions so you benefit from others’ experience.',
  },
  {
    icon: 'Database',
    title: 'Data',
    text: 'After specific market data? We work with you to source it, or to ‘create it’ through surveys with close media partners in the education sector.',
  },
  {
    icon: 'Lightbulb',
    title: 'Consultancy',
    text: 'We have an array of consultants across multiple disciplines. Contact us for additional ways we can help.',
  },
];

export const CAPABILITIES = [
  'Challenge your thinking',
  'Refine your plans',
  'Deliver market insight',
  'Provide Mentoring',
  'Bespoke advice',
  'Exclusive data',
];

export const PILLARS = [
  {
    icon: 'Target',
    title: 'Focused',
    text: 'A consultancy solely dedicated to education and helping businesses within the sector succeed. That singularity means less distraction and more relevance to your business.',
  },
  {
    icon: 'BrainCircuit',
    title: 'Knowledgeable',
    text: 'Our experience has depth, with the principals firmly embedded within the UAE education sector, with access to a wide range of data, and real-world specialists and expertise.',
  },
  {
    icon: 'Wrench',
    title: 'Practical',
    text: 'The data and insights we deliver to businesses within the education sector are designed to be practical not theoretical — able to drive positive, real-world change.',
  },
];

export const PARTNERS = [
  { name: 'WhichSchoolAdvisor.com', url: 'https://whichschooladvisor.com' },
  { name: 'SchoolsCompared.com', url: 'https://schoolscompared.com' },
];

// Which Media group brand logos (company assets).
export const WHICH_MEDIA = { name: 'Which Media', logo: '/brands/which-media.png', url: 'https://which-media.com' };

export const GROUP_BRANDS = [
  { name: 'WhichSchoolAdvisor', logo: '/brands/which-school-advisor.png', url: 'https://whichschooladvisor.com' },
  { name: 'SchoolsCompared', logo: '/brands/schools-compared.png', url: 'https://schoolscompared.com' },
  { name: 'WhichUniversityAdvisor', logo: '/brands/which-university-advisor.png', url: '' },
  { name: 'EdinformaPlus', logo: '/brands/edinforma-plus.png', url: '' },
];

export const FAQS = [
  {
    q: 'What type of consultancy / data do you provide?',
    a: 'We provide data and consultancy for existing UAE schools, and for investors and international school groups looking to establish a presence within the UAE.',
  },
  {
    q: 'What reports can we buy from EIG?',
    a: 'Our editorial calendar covers the Dubai, Abu Dhabi, Sharjah, Ras Al Khaimah and Al Ain education landscapes, the Early Years sector, the cost of schooling, setting up a school in the UAE, British / American / IB / Indian curriculum schools, school marketing and admissions, teacher recruitment and retention, e-learning, and more. Pre-register with us so we can share schedules.',
  },
  {
    q: 'When are these reports coming? There is one I specifically want…',
    a: 'Contact us for the schedule — we are happy to tell you when a specific report is due.',
  },
  {
    q: 'I cannot see the report that I want?',
    a: 'Contact us. It may be that we have the data you are looking for and are in a position to create the report for you.',
  },
  {
    q: 'I am interested in consultancy/data for something quite specific — how can I know you can help?',
    a: 'Our consultants work across the education sector — in schools, regulatory bodies, across curricula and in very different roles. The chances are we can meet your needs. In the first instance we simply meet to talk through your challenges, then put together a needs-based plan that is fit for purpose.',
  },
  {
    q: 'I want to come in for a chat. Are you based in the UAE?',
    a: 'Yes, EIG is headquartered in Dubai. Pop into our office, or we can come to visit you. If you are based outside of the UAE, an initial telephone / video call can suffice to get us going.',
  },
  {
    q: 'What is the source of your data / information?',
    a: 'We have multiple sources of data, including our media outlets such as WhichSchoolAdvisor.com, our own surveys (we have extensive lists of parents and educators), and our industry peers.',
  },
  {
    q: 'What is your relationship to WhichSchoolAdvisor.com?',
    a: 'WSA is a source of competitive intelligence for us. It is co-owned by a principal consultant at EIG.',
  },
];

export const REPORTS = [
  {
    id: 'from-the-ground-up',
    title: 'From the Ground Up',
    subtitle: 'The Knowledge Economy Report | 2019',
    year: '2019',
    tag: 'Investor Assessment',
    pages: 98,
    cover: '/reports/from-the-ground-up.png',
    summary:
      'An opportunity assessment for investors and school operators, with Property Finder \u2014 mapping where new homes are built against where schools and their fees sit.',
  },
  {
    id: 'mystery-shoppers',
    title: 'The Dubai Schools Mystery Shopper Report',
    subtitle: 'A report by the Education Intelligence Group',
    year: '2017',
    tag: 'Admissions',
    pages: 35,
    cover: '/reports/mystery-shoppers.png',
    summary:
      'We audit the admissions funnel \u2014 websites, telephone handling and school visits \u2014 to reveal what really happens when a parent enquires.',
  },
  {
    id: 'ei-issue-1',
    title: 'Education Intelligence \u2014 Issue 01',
    subtitle: 'The Good, the Bad, and the Ugly',
    year: '2019',
    tag: 'Journal',
    pages: 44,
    cover: '/reports/ei-issue-1.png',
    summary:
      'Are UAE teachers happy? KHDA ratings, the biggest movers and shakers in UAE careers, and why \u2018Good\u2019 is good enough for many schools.',
  },
  {
    id: 'ei-issue-2',
    title: 'Education Intelligence \u2014 Issue 02',
    subtitle: 'A market in flux',
    year: '2020',
    tag: 'Journal',
    pages: 158,
    cover: '/reports/ei-issue-2.png',
    summary:
      'Is there an end to over-supply and fee reductions? School-fee trends, the 2nd annual teacher survey and the recruitment \u2018crisis\u2019.',
  },
  {
    id: 'teaching-landscape',
    title: 'The Teaching Landscape of the UAE',
    subtitle: 'The Voices of Teachers in the UAE',
    year: '',
    tag: 'Teachers',
    pages: 47,
    cover: '/reports/teaching-landscape.png',
    summary:
      'Teacher recruitment and retention \u2014 the demographic landscape of UAE teachers and the global competition for talent schools now face.',
  },
  {
    id: 'professional-learning',
    title: 'Perceptions of Professional Learning',
    subtitle: 'Teachers in the United Arab Emirates',
    year: '',
    tag: 'Teachers',
    pages: 18,
    cover: '/reports/professional-learning.png',
    summary:
      'As teacher licensing becomes reality, how teachers across the UAE actually experience professional learning \u2014 and what it takes to retain top talent.',
  },
];

// Real data points drawn from the EIG reports (for the home insights band).
export const INSIGHTS = [
  { value: '55%', label: 'of combined income some Dubai residents spend on housing and education', source: 'From the Ground Up' },
  { value: '$20m+', label: 'estimated UAE school advertising spend in a single year', source: 'Mystery Shopper Report' },
  { value: '580', label: 'private schools now operating across the UAE', source: 'Education Intelligence \u2014 Issue 02' },
  { value: '13,000', label: 'more school seats coming to Dubai as new schools open', source: 'Education Intelligence \u2014 Issue 02' },
];

export const QUOTES = [
  {
    text: 'The power is back in the hands of parents \u2014 sub-optimal processes may prevent schools from developing their pipeline of prospects.',
    source: 'The Dubai Schools Mystery Shopper Report',
  },
  {
    text: 'There seems to be no end to the over-availability of school places, and reductions in fees or the inclusion of benefits that were previously chargeable.',
    source: 'Education Intelligence \u2014 Issue 02',
  },
  {
    text: 'Their expertise is unique and it should not be underestimated.',
    source: 'The Teaching Landscape of the UAE',
  },
];
